import React from 'react';
import { List, AutoSizer, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import { MenuItem } from 'react-bootstrap';
import { isArray, isNull } from 'lodash';
import PropTypes from 'prop-types';

import { getActiveStatus } from '../helpers';

const VirtualList = ({ items, withServicesId, doRequestFunc, queryString, queryRequest, withAll }) => {
  const cache = new CellMeasurerCache({
    fixedWidth: true,
    minHeight: 20,
  });

  const rowCount = isArray(items) ? items.length : 0;
  if (isNull(items?.key)) {
    return <div>{items}</div>;
  }

  return (
    <AutoSizer disableHeight>
      {({ width }) => (
        <List
          deferredMeasurementCache={cache}
          overscanRowCount={0}
          width={width}
          height={300}
          rowCount={rowCount}
          rowHeight={cache.rowHeight}
          rowRenderer={({ index, style, key, parent }) => {
            const elem = items[index];

            return (
              <CellMeasurer key={key} cache={cache} parent={parent} columnIndex={0} rowIndex={index}>
                <MenuItem
                  key={index}
                  style={style}
                  className={
                    String(getActiveStatus(queryString, queryRequest, withAll)) === String(elem.id) && elem.active === false
                      ? 'custom__active-dropdown--item not-active-service'
                      : String(getActiveStatus(queryString, queryRequest, withAll)) === String(elem.id)
                        ? 'custom__active-dropdown--item'
                        : elem.active === false
                          ? 'not-active-service'
                          : ''
                  }
                  eventKey={elem.id}
                  active={String(getActiveStatus(queryString, queryRequest, withAll)) === String(elem.id)}
                  onSelect={(key) => {
                    doRequestFunc(key);
                  }}
                >
                  {withServicesId && elem.id !== null && <span className="item-id">{elem.id}</span>}
                  {elem.title}
                </MenuItem>
              </CellMeasurer>
            );
          }}
        />
      )}
    </AutoSizer>
  );
};

VirtualList.propTypes = {
  items: PropTypes.array,
  withServicesId: PropTypes.bool,
  doRequestFunc: PropTypes.func,
  queryString: PropTypes.object,
  queryRequest: PropTypes.string,
  withAll: PropTypes.bool,
};

export default VirtualList;
